export enum InPersonClinicDetails {
  NAME = 'QuickMD clinic',
  ADDRESS = '601 Beacon Pkwy W #210',
  CITY = 'Birmingham',
  STATE = 'Alabama',
  ZIP_CODE = '35209',
}

export const IN_PERSON_CLINIC_FULL_ADDRESS = `${InPersonClinicDetails.ADDRESS} ${InPersonClinicDetails.CITY}, ${InPersonClinicDetails.STATE} ${InPersonClinicDetails.ZIP_CODE}`;
